<template>
  <div class="">
    <section class="bg-n3black text-white relative">
      <div class="container">
        <div class="py-5 sm:py-10">
          <div v-if="loadingStatus">
            <div role="status" class="max-w-xl animate-pulse">
              <div class="h-10 bg-gray-200 dark:bg-gray-700 w-3/6 mb-4"></div>
              <div
                class="h-3 bg-gray-200 dark:bg-gray-700 w-6/6 mb-5"
                v-for="(line, index) in 6"
                :key="index"
              ></div>
            </div>
          </div>
          <div v-else>
            <component :is="statusComponent"></component>
          </div>
        </div>
      </div>
      <!-- ! Container end -->
    </section>
  </div>
</template>
<script>
import Success from "./Success.vue";
import Fail from "./Fail.vue";
import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  onMounted,
  onUnmounted,
  reactive,
  toRefs,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import { decrypt, sumByCol } from "@/utils/helper";
import { PaymentStatusComponent, ReservationStatus } from "@/utils/enum";
import { useRoute } from "vue-router";

export default {
  name: "PaymentSummaryPage",
  components: { Fail, Success },
  setup() {
    const store = useStore();
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const state = reactive({
      statusComponent: "",
      loadingStatus: true,
      event: computed(() => store.state.event.event),
      currentUser: computed(() => store.state.auth.currentUser),
      show: computed(() => store.state.show.show),
      reservation: computed(() => store.state.reservation.reservation),
      reservationID: computed(() => store.state.reservation.reservationID),
      selectedSeatSummary: computed(
        () => store.getters["order/selectedSeatSummary"]
      ),
      sumByCol: computed(() => (obj, col) => {
        return sumByCol(obj, col);
      }),
    });

    const paymentStatusHandler = {
      success: async () => {
        await store.dispatch("reservation/detach");
        state.statusComponent = PaymentStatusComponent.SUCCESS;
        state.loadingStatus = false;
      },
      fail: () => {
        state.loadingStatus = true;
        state.statusComponent = PaymentStatusComponent.FAILED;
        const data = {
          stateReason: "PAYMENT_FAILED",
          state: ReservationStatus.FAILED,
        };
        store.dispatch("reservation/setStatus", data).then(() => {
          store.dispatch("reservation/detach");
          state.statusComponent = PaymentStatusComponent.FAILED;
          state.loadingStatus = false;
        });
      },
    };

    onBeforeMount(() => {
      store.dispatch("event/setState", { key: "showHeader", value: true });
    });

    onUnmounted(() => {
      store.dispatch("event/setState", { key: "showHeader", value: false });
    });

    onMounted(() => {
      try {
        const dataText = decrypt(proxy.$route.query.t);
        const responseParam = JSON.parse(dataText);
        if (responseParam.resId !== state.reservationID) {
          proxy.$router.push({ name: "404" });
        }
        if (!state.show.id) {
          store.dispatch("show/findShow", route.params.showSlug).then(() => {
            if (
              typeof paymentStatusHandler[responseParam.status] !== "undefined"
            ) {
              paymentStatusHandler[responseParam.status]();
            }
          });
        }
      } catch (error) {
        proxy.$router.push({ name: "404" });
      }
    });
    return {
      ...toRefs(state),
    };
  },
};
</script>
